var _  = require('lodash');

const Menu =  [    
  {title: 'Login', name: 'login', meta:{public:true, guest:true}},
  {title: 'Device Register', name: 'device-register', meta:{public:true, guest:true}},
  {        
    group: 'profile',        
    visible : false,
    items: [       
      { title: 'My Profile', meta:{breadcrumb:false} },                 
      { title: 'Update Profile', name : 'form'},          
    ]
  },

];

import Remenu from '@/util/remenu'
export default Remenu(Menu);